import { useEffect, useRef, useState } from "react";
import { Row } from "react-bootstrap";

import {
  defaultGridStateModalDataTable,
  orchestratorConstants,
  storeConstants,
} from "../../../../constants";
import { DataTableComponent } from "../../../../shared/components";
import CustomBodyModal from "../../../../shared/components/modal/CustomBodyModal";
import { getResetInventoryColumns } from "../../../../shared/utility";
import ConfirmationModal from "../../../Inventory/Items/ConfirmationModal/ConfirmationModal";
import ResetStatusDetailViewModal from "./ResetStatusDetailViewModal";

const ResetStatusModals = ({
  currentStore,
  isShowStoreProgress,
  showViewStatusModal,
  toggleViewStatusModal,
  storeMiscData,
  dfCancelOrchestrator,
  disableCancelResetConfirmationButtons,
  getStoreMiscData,
}) => {
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [columns, setColumns] = useState([]);
  const [cancelResetProgress, setCancelResetProgress] = useState(null);
  let numOfRenders = useRef(0);
  const [gridState, setGridState] = useState(defaultGridStateModalDataTable);

  const handleViewStatus = (status) => {
    setSelectedStatus(status);
  };
  const handleCancelResetProgress = (status) => {
    setCancelResetProgress(status);
  };

  const toggleConfirmationModal = () => {
    setCancelResetProgress(null);
  };
  const handleCloseDetailModal = () => {
    setSelectedStatus(null);
  };
  const handleCancelResetProgressSubmit = () => {
    const dataToSend = {
      id: cancelResetProgress?.id,
      storeId: currentStore?.id,
      orchestrator: orchestratorConstants.UPDATE_INVENTORY_PRESETS,
    };
    dfCancelOrchestrator(dataToSend);
    setCancelResetProgress(null);
  };
  useEffect(() => {
    if (showViewStatusModal) {
      getStoreMiscData(
        currentStore.id,
        storeConstants.BG_JOB_RESET_INVENTORY_WITH_SHOPIFY
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showViewStatusModal]);
  useEffect(() => {
    setColumns(
      getResetInventoryColumns({
        handleViewStatus: handleViewStatus,
        handleCancelResetProgress,
      })
    );
  }, []);

  return (
    <>
      <CustomBodyModal
        title="Reset Shopify Status"
        show={showViewStatusModal}
        onHide={toggleViewStatusModal}
        size="xl"
      >
        <Row className="m-0 p-0 w-100">
          <DataTableComponent
            resizableColumns={false}
            responsive={false}
            className="editable-table"
            columns={columns}
            data={storeMiscData}
            key={numOfRenders.current}
            total={storeMiscData?.length || 0}
            gridState={gridState}
            setGridState={setGridState}
          />
        </Row>
      </CustomBodyModal>

      {selectedStatus && (
        <ResetStatusDetailViewModal
          selectedStatus={selectedStatus}
          isShowStoreProgress={isShowStoreProgress}
          handleCloseDetailModal={handleCloseDetailModal}
        />
      )}
      <ConfirmationModal
        isConfirmationModal={cancelResetProgress}
        toggleConfirmationModal={toggleConfirmationModal}
        message="Are you sure want to cancel this reset progress?"
        handleNoButtonClick={toggleConfirmationModal}
        handleYesButtonClick={handleCancelResetProgressSubmit}
        isLoading={disableCancelResetConfirmationButtons}
      />
    </>
  );
};

export default ResetStatusModals;
